import type {GetServerSideProps} from 'next';
import {
  EntryManagementLayout,
  SIDE_MENU_ID_LIST,
} from '../../../../features/entryManagements/components/EntryManagementLayout';
import {EntryManagementsProgressPage} from '../../../../features/entryManagements/components/EntryManagementsProgressPage';
import {
  type OptionalUserAnalyticsProps,
  getOptionalUserAnalyticsProps,
} from '../../../../features/entryManagements/usecase/getOptionalUserAnalyticsProps';
import {withHandler} from '../../../../server/token/withHandler';
import {ScriptForGA} from '../../../../shared/components/ScriptForGA';
import type {NextPageWithLayout} from '../../../_app';

export const getServerSideProps: GetServerSideProps = withHandler<
  OptionalUserAnalyticsProps,
  'withOptionalSession'
>({auth: 'optional'}, getOptionalUserAnalyticsProps);

const Page: NextPageWithLayout<OptionalUserAnalyticsProps> = ({
  userDataForAnalytics,
}) => {
  return (
    <>
      <EntryManagementsProgressPage />
      <ScriptForGA userDataForAnalytics={userDataForAnalytics} />
    </>
  );
};

Page.getLayout = (page) => (
  <EntryManagementLayout current={SIDE_MENU_ID_LIST.PROGRESS}>
    {page}
  </EntryManagementLayout>
);

export default Page;
